<template>
    <header class="Header section-header">
            <a class="back" v-show='!BackPage' @click="$router.push({name:'home'})"><img :src="IcHome" alt=""></a>

            <a class="back" v-if='BackPage' @click="$router.go(-1)" ><img :src="IcBack" alt=""></a>

            <img v-show='Logo' class="logoImg"  :src="logo" @click="$router.push('/')" alt="">

            <h1>{{Title}}</h1>
            

            <a
            v-show="HideCart"
            @click="goToCart"
            >
                <img class="cartImg" :src="cart" alt="">
                <span v-if='this.pre_cart_total > 0'  class="notify">{{this.pre_cart_total}}</span>
            </a>
 
    </header>
</template>

<script>
import appName from '../../assets/img/appName.svg'
import cartButton from '../../assets/img/icCart.svg'
import IcBack from '../../assets/img/icArrowLeftBlack.svg'
import IcHome from '../../assets/img/icHome.svg'
import {mapState,mapActions} from 'vuex'

    export default {
        props: {
            Title: {
                type: String,
            },
            BackPage: {
                type: Boolean,
            },
            HomePage: {
                type: Boolean,
            },
            Logo: {
                type: Boolean,
                default: false,
            },
            HideCart : {
                type: Boolean,
            },
        },
        data() {
            return {
                logo: appName,
                cart:cartButton,
                IcBack:IcBack,
                IcHome:IcHome,
            }
        },
        computed: {
            ...mapState('pre_cart',['pre_cart_total','pre_cart_itens']),
            
            userLocalId (){
                return localStorage.getItem('id_user');
            },

        },
        methods: {
            ...mapActions('pre_cart',['ActionGetCartComplete','ActionDeleteCartComplete','ActionGetPreCart']),
            async goToCart() {
                this.$router.push({name:'cart_checkout'})
            }
        },
        created () {
            this.ActionGetPreCart({user:this.userLocalId})
        },

    }
</script>

<style lang="css" scoped>

.Header {  
  display: flex;
  justify-content: space-between;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 1000000;
  padding: 1rem 1rem 0.1rem;
  background-color: var(--main-white);
  
 
  /* box-shadow: 0 3px 3px rgba(0,0,0,0.6); */}
h1 {
  font-size: 1rem;
  font-weight:900;
  padding-top:1%;
  font-family: 'Roboto',sans-serif;
  color:var(--main-red-black);
  text-transform:uppercase;
}
a {
  font-size: 0.714rem;
  color: var(--main-black);
  position: relative;
  top: -0.66rem;
}
.logoImg {
    position:relative;
    top: -0.86rem;
    
}
.cartImg {
    position:relative;
    top: 0.65rem;
    cursor:pointer;
}
.back{
    
    position:relative;
    top: 0.10rem;
    cursor:pointer;
   
}


  @media (min-width: 1000px) and (max-width: 2600px) {
        .Header {  
        display: flex;
        justify-content:space-between;
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        z-index: 1000000;
        padding: 1rem 1rem 0.1rem;
        background-color: var(--main-white);
  
 
  /* box-shadow: 0 3px 3px rgba(0,0,0,0.6); */}
  }


  @media (min-width: 600px) and (max-width: 800px) {
    header {
        padding: 1rem 10% 2.214rem;
    }
  }
  @media (min-width: 800px) and (max-width: 1400px) {
    header{
        padding: 1rem 25% 2.214rem;
    }
  }
  @media (min-width: 1400px) and (max-width: 2600px) {
    header{
        padding: 1rem 15% 2.214rem;
    }
  }
  div {
    padding: 0.8rem 0;
    text-transform: uppercase;
  
}


</style>